import ArrowBack from "@mui/icons-material/ArrowBack";
import PropTypes from "prop-types";

import { Box, Button, Link } from "@/components/core";
import { Navbar } from "../navbar";

export function PageWrapper({ title, href = "/", rightPane, children }: any) {
  return (
    <Box>
      <Navbar />
      <Box sx={{ p: 3 }}>
        <Box sx={{ m: 2, display: "flex", justifyContent: "space-between" }}>
          <Link href={href}>
            <Button
              sx={{ color: "inherit", fontSize: "2rem" }}
              startIcon={<ArrowBack fontSize="large" />}
            >
              {title}
            </Button>
          </Link>
          {rightPane}
        </Box>

        {children}
      </Box>
    </Box>
  );
}

PageWrapper.propTypes = {
  title: PropTypes.string,
  href: PropTypes.string,
  rightPane: PropTypes.node,
  children: PropTypes.node,
};
